import React from "react"
import { CustomIconsType } from "../types"

import { BarProgress } from "./generalCustomIcons"

import {
  AppliedTechnologyIcon,
  EssentialSkillsIcon,
  MechanicsIcon,
  ElectricityIcon,
  ThermodynamicsIcon,
  AppliedMathIcon,
  FluidDynamicsIcon,
  ProblemSolvingIcon,
  WorkDisciplineIcon,
  WorkingInTeamsIcon,
  BusinessWritingIcon,
  GraphicLiteracyIcon,
  CustomerServiceIcon,
  CriticalThinkingIcon,
  WorkplaceDocumentsIcon,
  FinancialAwarenessIcon,
  WorkplaceObservationIcon,
  BusinessCommunicationIcon
} from "./workkeysCoursesCustomIcons"

const CUSTOM_ICONS: Record<CustomIconsType, React.FC> = {
  // General Custom Icons
  "bar-progress": BarProgress,

  // Workkeys Courses Custom Icons
  "applied-technology": AppliedTechnologyIcon,
  "essential-skills": EssentialSkillsIcon,
  mechanics: MechanicsIcon,
  electricity: ElectricityIcon,
  thermodynamics: ThermodynamicsIcon,
  "applied-math": AppliedMathIcon,
  "fluid-dynamics": FluidDynamicsIcon,
  "problem-solving": ProblemSolvingIcon,
  "work-discipline": WorkDisciplineIcon,
  "working-in-teams": WorkingInTeamsIcon,
  "business-writing": BusinessWritingIcon,
  "graphic-literacy": GraphicLiteracyIcon,
  "customer-service": CustomerServiceIcon,
  "critical-thinking": CriticalThinkingIcon,
  "workplace-documents": WorkplaceDocumentsIcon,
  "financial-awareness": FinancialAwarenessIcon,
  "workplace-observation": WorkplaceObservationIcon,
  "business-communication": BusinessCommunicationIcon
}

const getCustomIconComponent = (name: CustomIconsType): React.FC => {
  return CUSTOM_ICONS[name] || null
}

export default getCustomIconComponent
